export default __webpack_public_path__ + "../staticImages/medaille-bester-haendler.png";